export const getAvailableQuantityLimit = (availableQuantity, quantityTagThreshold) => {
    if (quantityTagThreshold === undefined || availableQuantity.isUnlimited)
        return;
    if (quantityTagThreshold >= availableQuantity.value)
        return availableQuantity.value;
};
